export interface IncomeTaxDeclarationTwo {
    item?: string,
    align: string,
    quantity?: string,
    amount?: string,
    indent?: number | string,
    isHead?: boolean,
    row?: string,
    justCol3?: boolean,
    canEdit?: boolean,
    rowspan?: number,
    col?: string,
}

let list: IncomeTaxDeclarationTwo[] = [
    {
        item: "一、免税收入（2+3+8+9…+15）",
        align: "left",
        col: "1",
        row: "0",
        amount: "0",
    },
    {
        item: "（一）国债利息收入免征企业所得税",
        align: "left",
        col: "2",
        row: "1",
        amount: "0",
        canEdit: true
    },
    {
        item: "（二）符合条件的居民企业之间的股息，红利等权益性投资收益免征企业所得税（4+5.1+5.2+6+7）",
        align: "left",
        col: "3",
        row: "2",
        amount: "0",
    },
    {
        item: "1.一般股息红利等权益性投资收益免征企业所得税",
        align: "left",
        col: "4",
        row: "3",
        amount: "0",
        indent: "20",
        canEdit: true
    },
    {
        item: "2.内地居民企业通过沪港通投资且连续持有H股满12个月取得的股息红利所得免征企业所得税",
        align: "left",
        col: "5.1",
        row: "4",
        amount: "0",
        indent: "20",
        canEdit: true
    },
    {
        item: "3.内地居民企业通过深港通投资且连续持有H股满12个月取得的股息红利所得免征企业所得税",
        align: "left",
        col: "5.2",
        row: "5",
        amount: "0",
        indent: "20",
        canEdit: true
    },
    {
        item: "4.居民企业持有创新企业CDR取得的股息红利所得免征企业所得税",
        align: "left",
        col: "6",
        row: "6",
        amount: "0",
        indent: "20",
        canEdit: true
    },
    {
        item: "5.符合条件的居民企业之间属于股息、红利性质的永续债利息收入免征企业所得税",
        align: "left",
        col: "7",
        row: "7",
        amount: "0",
        indent: "20",
        canEdit: true
    },
    {
        item: "（三）符合条件的非营利组织的收入免征企业所得税",
        align: "left",
        col: "8",
        row: "8",
        amount: "0",
        canEdit: true
    },
    {
        item: "（四）中国清洁发展机制基金取得的收入免征企业所得税",
        align: "left",
        col: "9",
        row: "9",
        amount: "0",
        canEdit: true
    },
    {
        item: "（五）投资者从证券投资基金分配中取得的收入免征企业所得税",
        align: "left",
        col: "10",
        row: "10",
        amount: "0",
        canEdit: true
    },
    {
        item: "（六）取得的地方政府债券利息收入免征企业所得税",
        align: "left",
        col: "11",
        row: "11",
        amount: "0",
        canEdit: true
    },
    {
        item: "（七）中国保险保障基金有限责任公司取得的保险保障基金等收入免征企业所得税",
        align: "left",
        col: "12",
        row: "12",
        amount: "0",
        canEdit: true
    },
    {
        item: "（八）中国奥委会取得北京冬奥组委支付的收入免征企业所得税",
        align: "left",
        col: "13",
        row: "13",
        amount: "0",
        canEdit: true
    },
    {
        item: "（九）中国残奥委会取得北京冬奥组委分期支付的收入免征企业所得税",
        align: "left",
        col: "14",
        row: "14",
        amount: "0",
        canEdit: true
    },
    {
        item: "（十）其他",
        align: "left",
        col: "15",
        row: "15",
        amount: "0",
    },
    {
        item: "二、减计收入（17+18+22+23）",
        align: "left",
        col: "16",
        row: "16",
        amount: "0",
    },
    {
        item: "（一）综合利用资源生产产品取得的收入在计算应纳税所得额时减计收入",
        align: "left",
        col: "17",
        row: "17",
        amount: "0",
        canEdit: true
    },
    {
        item: "（二）金融、保险等机构取得的涉农利息、保费减计收入（19+20+21）",
        align: "left",
        col: "18",
        row: "18",
        amount: "0",
    },
    {
        item: "1.金融机构取得的涉农贷款利息收入在计算应纳税所得额时减计收入",
        align: "left",
        col: "19",
        row: "19",
        amount: "0", indent: "20",
        canEdit: true
    },
    {
        item: "2.保险机构取得的涉农保费收入在计算应纳税所得额时减计收入",
        align: "left",
        col: "20",
        row: "20",
        amount: "0", indent: "20",
        canEdit: true
    },
    {
        item: "3.小额贷款公司取得的农户小额贷款利息收入在计算应纳税所得额时减计收入",
        align: "left",
        col: "21",
        row: "21",
        amount: "0", indent: "20",
        canEdit: true
    },
    {
        item: "（三）取得铁路债券利息收入减半征收企业所得税",
        align: "left",
        col: "22",
        row: "22",
        amount: "0",
        canEdit: true
    },
    {
        item: "（四）其他（23.1+23.2）",
        align: "left",
        col: "23",
        row: "23",
        amount: "0",
    },
    {
        item: "1.取得的社区家庭服务收入在计算应纳税所得额时减计收入",
        align: "left",
        col: "23.1",
        row: "24",
        amount: "0",
        indent: "20",
        canEdit: true
    },
    {
        item: "2.其他",
        align: "left",
        col: "23.2",
        row: "25",
        amount: "0",
        indent: "20",
        canEdit: true
    },
    {
        item: "三、加计扣除（25+26+27+28）",
        align: "left",
        col: "24",
        row: "26",
        amount: "0",
    },
    {
        item: "（一）开发新技术、新产品、新工艺发生的研究开发费用加计扣除",
        align: "left",
        col: "25",
        row: "27",
        amount: "0",
        canEdit: true
    },
    {
        item: "（二）科技型中小企业开发新技术、新产品、新工艺发生的研究开发费用加计扣除",
        align: "left",
        col: "26",
        row: "28",
        amount: "0",
        canEdit: true
    },
    {
        item: "（三）企业为获得创新性、创意性、突破性的产品进行创意设计活动而发生的相关费用加计扣除",
        align: "left",
        col: "27",
        row: "29",
        amount: "0",
        canEdit: true
    },
    {
        item: "（四）安置残疾人员所支付的工资加计扣除",
        align: "left",
        col: "28",
        row: "30",
        amount: "0",
        canEdit: true
    },
    {
        item: "四、所得减免（30+33+34+35+36+37+38+39+40）",
        align: "left",
        col: "29",
        row: "31",
        amount: "0",
    },
    {
        item: "（一）从事农、林、牧、渔业项目的所得减免征收企业所得税（31+32）",
        align: "left",
        col: "30",
        row: "32",
        amount: "0",
    },
    {
        item: "1.免税项目",
        align: "left",
        col: "31",
        row: "33",
        amount: "0",
        indent: "20",
        canEdit: true
    },
    {
        item: "2.减半征收项目",
        align: "left",
        col: "32",
        row: "34",
        amount: "0",
        indent: "20",
        canEdit: true
    },
    {
        item: "（二）从事国家重点扶持的公共基础设施项目投资经营的所得定期减免企业所得税",
        align: "left",
        col: "33",
        row: "35",
        amount: "0",
        canEdit: true
    },
    {
        item: "其中：从事农村饮水安全工程新建项目投资经营的所得定期减免企业所得税",
        align: "left",
        col: "33.1",
        row: "36",
        amount: "0",
        indent: "20",
        canEdit: true
    },
    {
        item: "（三）从事符合条件的环境保护、节能节水项目的所得定期减免企业所得税",
        align: "left",
        col: "34",
        row: "37",
        amount: "0",
        canEdit: true
    },
    {
        item: "（四）符合条件的技术转让所得减免征企业所得税",
        align: "left",
        col: "35",
        row: "38",
        amount: "0",
        canEdit: true
    },
    {
        item: "（五）实施清洁发展机制项目的所得定期减免企业所得税",
        align: "left",
        col: "36",
        row: "39",
        amount: "0",
        canEdit: true
    },
    {
        item: "（六）符合条件的节能服务公司实施合同能源管理项目的所得定期减免企业所得税",
        align: "left",
        col: "37",
        row: "40",
        amount: "0",
        canEdit: true
    },
    {
        item: "（七）线宽小于130纳米的集成电路生产项目的所得减免企业所得税",
        align: "left",
        col: "38",
        row: "41",
        amount: "0",
        canEdit: true
    },
    {
        item: "（八）线宽小于65纳米或投资额超过150亿元的集成电路生产项目的所得减免企业所得税",
        align: "left",
        col: "39",
        row: "42",
        amount: "0",
        canEdit: true
    },
    {
        item: "（九）其他",
        align: "left",
        col: "40",
        row: "43",
        amount: "0",
        canEdit: true
    },
    {
        item: "合计（1+16+24+29）",
        align: "left",
        col: "41",
        row: "44",
        amount: "0"
    },
    {
        item: "附列资料：支持新型冠状病毒感染的肺炎疫情防控捐赠支出全额扣除 ",
        align: "left",
        col: "42",
        row: "45",
        amount: "0",
        canEdit: true,
    },
    {
        item: "扶贫捐赠支出全额扣除",
        align: "left",
        col: "43",
        row: "46",
        amount: "0",
        canEdit: true,
    },

]


let EITQuarterTwo = list
export default EITQuarterTwo
